import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import PageSection from '../../../../../../features/components/PageSection'
import HoverHelpTextIcon from '../../../../../../features/components/HoverHelpTextIcon'

import { useSroiReportCurrencySymbol } from '../../../hooks'
import { formatNumberToShort } from '../../../../helpers'

import { socialReturnOnInvestmentReportSelector } from '../../../../../../modules/selectors/socialReturnOnInvestment'

import { helpTexts } from '../../../constants'

import usePanelsStyles from '../styles'

const InvestmentCountPanel = () => {
  const { t } = useTranslation()

  const panelsClasses = usePanelsStyles()

  const { total_investment: totalInvestment, total_activity_hours: totalActivityHours } = useSelector(
    socialReturnOnInvestmentReportSelector
  )
  const currencySymbol = useSroiReportCurrencySymbol()

  return (
    <PageSection className={panelsClasses.panel}>
      <div className={panelsClasses.leftSide}>
        <h5 className={panelsClasses.valueTitle}>
          {t('Investment')} <HoverHelpTextIcon helpText={helpTexts.investment} />
        </h5>
        <div className={panelsClasses.value}>{currencySymbol}</div>
        <div className={panelsClasses.value}>{formatNumberToShort(totalInvestment, 2)}</div>
        <h5 className={panelsClasses.valueTitle}>{t('Total')}</h5>
      </div>
      <div className={panelsClasses.rightSide}>
        <h5 className={panelsClasses.valueTitle}>
          {t('Volunteering hours')} <HoverHelpTextIcon helpText={helpTexts.activityHours} />
        </h5>
        <div className={panelsClasses.value}>{formatNumberToShort(totalActivityHours, 0)}</div>
        <div className={panelsClasses.value}>{t('hrs')}</div>
        <h5 className={panelsClasses.valueTitle}>{t('Total')}</h5>
      </div>
    </PageSection>
  )
}

export default InvestmentCountPanel
